import { AutogenModelOfficePayrollProfile, AutogenRowOfficePayrollProfile } from "./autogen/AutogenModelOfficePayrollProfile";

export class ModelOfficePayrollProfile extends AutogenModelOfficePayrollProfile<RowOfficePayrollProfile> {
	constructor() {
		super(RowOfficePayrollProfile);
	}
}

export class RowOfficePayrollProfile extends AutogenRowOfficePayrollProfile {
}